module.exports = __webpack_public_path__ + "img/work_maum_list.ad50fedb.jpg";